const storeProvider = require('mn-utils/browser/storeProvider');
const router = require('./router');

// eslint-disable-next-line
export const localStore = storeProvider(require('mn-utils/browser/localStorage'));

export const paramStore = process.env.MOCK || location.hostname.includes('localhost')
  ? storeProvider(router.hashParamStorage)
  : storeProvider(router.paramStorage);
